export default __webpack_public_path__ + "static/media/iste_logo.d205f08b.png";